import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import ModuleSidebarLayout from "../inventory/components/ModuleSidebarLayout";
import { NAV_CONFIG } from "./constants";

export default function RadiologyLayout({ children }) {
  const history = useHistory();

  useEffect(() => {
    if (!sessionStorage.getItem("accessToken")) history.push("/login");
  }, [history]);

  return (
    <ModuleSidebarLayout
      navConfig={NAV_CONFIG}
      suiteBase=""
      storageKey="rad_sidebar_expanded"
      disableContentPadding
    >
      {children}
    </ModuleSidebarLayout>
  );
}
